export const prepareLocationUrl = (url) => {
  if ((/^\/.*/.test(url)) === false) {
    url = '/' + url
  }

  if ((/\/$|\?/.test(url)) === false) {
    url = url + '/';
  }

  return url;
};
